<div class="terms-conditions-block">
    <div class="block--wrap checkout-page__section checkout-page__section--tac-confirmation block">
        <h2 class="title">
            {{ 'SHOPPING_CART_TEXT_TERMS_CONDITIONS_TITLE' | translate }}
        </h2>
        <div class="group-checkboxes">
            <div class="item-tnc">
                <span class="checkbox-wcag">
                    <input
                        class="checkbox-wcag__checkbox"
                        [checked]="termsAgreed$ | async"
                        type="checkbox"
                        attr.aria-hidden="true"
                        required
                        tabindex="-1"
                        attr.aria-required="true"
                        attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{
                            'ASTERISK' | translate
                        }}" />

                    <span
                        class="checkbox-wcag__checkmark"
                        (click)="toggleTermsAgreed()"
                        (keydown.space)="toggleTermsAgreed()"
                        required
                        attr.aria-required="true"
                        tabindex="0"
                        attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{
                            'ASTERISK' | translate
                        }}"
                        role="checkbox">
                    </span>

                    <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                        <span>
                            <span
                                class="link-label"
                                (click)="toggleTermsAgreed()"
                                (keydown.enter)="toggleTermsAgreed()"
                                (keydown.space)="toggleTermsAgreed()">
                                {{ 'READ_TERMS' | translate }}
                            </span>

                            <a
                                class="link link--emphasized link--action"
                                #modalTrigger
                                (click)="openTerms()"
                                (keydown.enter)="openTerms()"
                                (keydown.space)="openTerms()"
                                tabindex="0">
                                {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}
                            </a>
                        </span>
                    </label>
                </span>
            </div>
        </div>

        <ridango-modal [size]="'800'" [visible]="termsModalVisible" [isItSmall]="false" (onCloseModal)="closeTerms()">
            <ridango-terms-modal-content [termsUrl]="termsUrl$ | async" (onAgree)="setTermsAcceptance($event)">
            </ridango-terms-modal-content>
        </ridango-modal>
    </div>
</div>
